import React from 'react'

import { Tag } from 'rsuite'
import { PAYMENT_OLD_STATUSES } from '@@partner:config/payment_statuses'

export interface PaymentStatusLabelProps {
  status: number
}

export default function PaymentStatusLabel ({ status }: PaymentStatusLabelProps) {

  if (status === undefined) {
    return null
  }
 
  return (
    <Tag 
      color={PAYMENT_OLD_STATUSES[status].color ?? 'green' }
      >
      { PAYMENT_OLD_STATUSES[status]?.description ?? ''}
    </Tag>
  )
}
